import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../modules/user';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {
	let users = [];
	if (state.lists.userIds) {
		users = _.map(state.lists.userIds,
			id => state.maps.user[id]
		);
	}
	return {
		users,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchUsers : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
